module.exports = __webpack_public_path__ + "static/main1_sp-6eb28be015b48c4f491cfd994468d567.jpg";